import axios from "axios";
import qs from "qs";
// const preUrl = "http://8.140.52.241:8400";
const preUrl = "http://112.51.251.245:8300";
axios.defaults.baseURL = preUrl;

//查询文章列表
export const articleListApi = params => {
  return axios
    .get(`/api/article/list?` + qs.stringify(params))
    .then(res => res.data);
};
// 获取文章详细信息
export const articleDetailApi = params => {
  return axios.get(`/api/article/${params.articleId}`).then(res => res.data);
};

// 文章附件列表
export const accessoryListApi = params => {
  return axios
    .get(`/api/accessory/list?` + qs.stringify(params))
    .then(res => res.data);
};

// 获取文章附件详细信息
export const accessoryDetailApi = params => {
  return axios
    .get(`/api/accessory/${params.accessoryId}`)
    .then(res => res.data);
};

// 获取前端菜单下拉树列表
export const menuTreeApi = () => {
  return axios.get(`/api/uimenu/treeselect`).then(res => res.data);
};

// 查询前端菜单列表
export const menuListApi = params => {
  return axios
    .get(`/api/uimenu/list?` + qs.stringify(params))
    .then(res => res.data);
};
// 获取人员管理
export const personnelApi = params => {
  return axios
    .get(`/api/personnel/list?` + qs.stringify(params))
    .then(res => res.data);
};
// 获取服务指南详细信息
export const directoryApi = params => {
  return axios
    .get(`/api/directory/${params.serviceDirectoryId}`)
    .then(res => res.data);
};
// 获取观众问卷调查
export const optionsApi = params => {
  return axios.get(`/api/topic/list?`).then(res => res.data);
};

// 根据字典类型查询字典数据信息
export const dictDataApi = params => {
  return axios
    .get(`/api/dict/data/type/${params.dictType}`)
    .then(res => res.data);
};

// 新增问卷调查
export const newQuestionApi = params => {
  return axios.post(`/api/info`, params).then(res => res.data);
};

//banner获取
export const bannerApi = params => {
  return axios
    .get(`/api/banner/list?` + qs.stringify(params))
    .then(res => res.data);
};

// 首页典藏
export const getWenGenApi = () => {
  return axios.get(`/api/homePage/getWenGen`).then(res => res.data);
};
// 获取友情链接
export const getBlogrollApi = () => {
  return axios.get(`/api/blogroll/list`).then(res => res.data);
};

// 下载接口
// export const downloadApi = (params) => {
// 	return axios({
// 		method: 'get',
// 		url: "/common/downloadImage?" + "fileName=" + params,
// 		responseType: 'blob',
// 	})
// };

// 封装下载图片
export default function exportMethod(data, name) {
  axios({
      method: "get",
      url: "/common/downloadImage?" + "fileName=" + data,
      responseType: "blob"
    })
    .then(res => {
      try {
        const blobUrl = window.URL.createObjectURL(res);
        const a = document.createElement("a");
        a.style.display = "none";
        a.download = name;
        a.href = blobUrl;
        a.click();
      } catch (e) {
        console.log(e);
      }
    })
    .catch(error => {
      console.log(error);
    });
}

// 获取前端菜单详细信息
export const getOneMenuInfo = uiMenuId => {
  return axios.get(`/api/uimenu/${uiMenuId}`).then(res => res.data);
};
//
export const getDirectoryInfo = () => {
  return axios.get(`/api/directory/list`).then(res => res.data);
};



// WEBPACK FOOTER //
// ./src/assets/js/api.js